import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.spacing.sp4};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  background: ${props => props.theme.colors.disabled.surface};
`
